import {textareaWithVariables_normalizePillSpacers} from '../pill/normalize-spacers'


// Run spacer normalisation while keeping the collapsed caret in place.
//
// `normalizePillSpacers` wipes and re-adds zero-width spacer nodes; a
// caret resting in real text/element content survives (the node is not a
// spacer, so it is not removed). Because spacers are zero-width, even if
// the restored offset is off by a spacer position the result is visually
// identical and the selection snapper canonicalises it.
//
// Used by `onInput` after a NATIVE delete removed a pill, to clear any
// stray spacers the deletion left behind without losing the caret.
export function textareaWithVariables_normalizeKeepingCaret(editor: HTMLElement): void {
    const sel = window.getSelection()

    let savedNode  : Node | null = null
    let savedOffset = 0
    if (sel && sel.isCollapsed && sel.rangeCount > 0) {
        const r = sel.getRangeAt(0)
        if (editor.contains(r.startContainer)) {
            savedNode   = r.startContainer
            savedOffset = r.startOffset
        }
    }

    textareaWithVariables_normalizePillSpacers(editor)

    // Restore only if the anchor node is still in the tree (a caret that
    // sat inside a wiped spacer is left where the browser put it).
    if (sel && savedNode && editor.contains(savedNode)) {
        const max = savedNode.nodeType === Node.TEXT_NODE
            ? (savedNode.textContent || '').length
            : savedNode.childNodes.length
        const r = document.createRange()
        r.setStart(savedNode, Math.min(savedOffset, max))
        r.collapse(true)
        sel.removeAllRanges()
        sel.addRange(r)
    }
}
